import {Tooltip} from "@mantine/core";
import React from "react";

export default function GenericTooltip(props:{txt:string,innerHtml:React.JSX.Element}){
    return(
        <Tooltip  label={props.txt}>
            {props.innerHtml}
        </Tooltip>
    )
}